import { Link } from 'react-router-dom';
import { CARD_CLASSNAME } from '../../../constant/constant';
import { Brand } from '../../../interface/interface';

const BrandCard = ({
  brand,
  ariaHidden = false,
}: Readonly<{ brand: Brand; ariaHidden?: boolean }>) => {
  const card = (
    <div className={CARD_CLASSNAME}>
      <img
        src={brand.imageUrl}
        alt={brand.name}
        loading="lazy"
        decoding="async"
        className="h-auto max-h-[40px] w-auto max-w-[140px] object-contain"
      />
    </div>
  );

  if (ariaHidden) {
    return card;
  }

  if (brand.href) {
    return (
      <Link to={''} aria-label={brand.name} className="shrink-0">
        {card}
      </Link>
    );
  }

  return card;
};

export default BrandCard;
